export default "__VITE_ASSET__DoyjckQO__"